import PropTypes from 'prop-types'

// Internal components
import Svg from '../Svg/Svg'
import Tooltip from '../Tooltip/Tooltip'

const MaterialBlock = (props) => {
  const { data, modifiers } = props
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  return (
    <div className={`MaterialBlock${modifierClasses}`}>
      <ul className="MaterialBlock-list">
        {data.map((item, index) => {
          return (
            <li
              className={`MaterialBlock-item${item.tooltip ? ' has-tooltip' : ''}`}
              key={`MaterialBlock-item--${index}`}
            >
              {item.tooltip && <Tooltip content={item.tooltip} modifiers={['Tooltip--materialBlock']} />}
              <span className="MaterialBlock-icon">
                <Svg id={`symbol-${item.icon}`} modifiers={['MaterialBlock-svg']} />
              </span>
              <span className="MaterialBlock-amount">{item.label}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

MaterialBlock.propTypes = {
  data: PropTypes.array,
  modifiers: PropTypes.array
}

export default MaterialBlock
